<template>
  <meta
    v-if="visitorIdentificationTimestamp"
    name="VIcurrentDateTime"
    :content="visitorIdentificationTimestamp"
  />
</template>

<script>
import challengerEnv from './lib/challengerEnv';

/**
  VisitorIdentification is necessary for Sitecore Analytics to determine if the visitor is a robot.
  If Sitecore XP (with xConnect/xDB) is used, this is required or else analytics will not be collected for the JSS app.
  For XM (CMS-only) apps, this should be removed.

  VI detection only runs once for a given analytics ID, so this is not a recurring operation once cookies are established.
 */
export default {
  name: 'VisitorIdentification',
  data() {
    const visitorIdentificationTimestamp = this.$jss.sitecoreContext()
      .visitorIdentificationTimestamp;

    emitVIScript(visitorIdentificationTimestamp);

    return { visitorIdentificationTimestamp };
  },
};

let emittedVI = false;

function getMetatagContent() {
  var metas = document.getElementsByTagName('meta');

  for (var i = 0; i < metas.length; i++) {
    if (metas[i].getAttribute("name") == "VIcurrentDateTime") {
      return metas[i].getAttribute("content");
    }
  }

  return "";
}

function timeoutSleep(milliseconds, callbackFunction) {
  window.setTimeout(
    function() {
      callbackFunction();
    },
    milliseconds);
}

function placeCheckerRequest() {
    const cssFile2 = document.createElement('link');
    let fileTarget2 = '/layouts/system/VIChecker.aspx?tstamp=';
    if(challengerEnv().sitecoreContentAPI.host!==''){
      fileTarget2 = challengerEnv().sitecoreContentAPI.host + fileTarget2 + getMetatagContent();      
    }

    cssFile2.href = fileTarget2;
    cssFile2.type = 'text/css';
    cssFile2.rel = 'stylesheet';

    document.getElementsByTagName('head')[0].appendChild(cssFile2);
}

function emitVIScript(visitorIdentificationTimestamp) {
  if (!emittedVI && typeof document !== 'undefined' && visitorIdentificationTimestamp) {
    emittedVI = true;

    // const script = document.createElement('script');
    // let fileTarget = '/layouts/system/VisitorIdentification.js';
    // script.src = fileTarget;
    // script.type = 'text/javascript';
    // document.getElementsByTagName('head')[0].appendChild(script);

    // CUSTOM code - The above wworks only when the App is hosted on sitecore server and contnet API served with saem domain as the app
    // HOWEVER when hosted on separate server we need to make sure that the Content API domain is setup and passed through
    // Issue was VisitorIdentification.js on sitecore server is adding 2 aspx ref through css without passing the domain name.
    // Here we do the same logic but making sure the domain is passed on...
    const cssFile1 = document.createElement('link');
    let fileTarget = '/layouts/system/VisitorIdentificationCSS.aspx?';
    if(challengerEnv().sitecoreContentAPI.host!==''){
      fileTarget = challengerEnv().sitecoreContentAPI.host + fileTarget + new Date().getTime();      
    }

    cssFile1.href = fileTarget;
    cssFile1.type = 'text/css';
    cssFile1.rel = 'stylesheet';
 
    document.getElementsByTagName('head')[0].appendChild(cssFile1);

    timeoutSleep(30000, placeCheckerRequest);
  }
}
</script>
